import { useI18nContext } from "@hopper-b2b/i18n";
import type { GuestPickerComponentProps } from "./GuestPicker";

import { useGuestPicker as useCoreGuestPicker } from "~core-hotels/components";

export const useGuestPicker = (props: GuestPickerComponentProps) => {
  const { t } = useI18nContext();
  const coreReturnObj = useCoreGuestPicker(props);

  const onOpenChange = (open: boolean) => {
    if (!open) {
      // Apply changes when closing the modal
      coreReturnObj.handlers.onGuestSelection({
        adults: coreReturnObj.context.adultCount,
        children: coreReturnObj.context.childAgeArr,
      });
    }
    // Always call the original handler for tracking/side effects
    coreReturnObj.handlers.onOpenChange(open);
  };

  return {
    ...coreReturnObj,
    handlers: {
      ...coreReturnObj.handlers,
      onOpenChange,
    },
    text: {
      ...coreReturnObj.text,
      buttonFloatingLabel: t(
        "core-hotels.search.guestPicker.buttonFloatingLabel"
      ),
    },
  };
};
